export default "__VITE_ASSET__314fb321__"